/* eslint-disable no-process-env */

module.exports = {
  version: process.env.VERSION,
  contentCreatorAdminAPI: {
    url: '/api/{version}/',
    endpoints: {
      campaigns: 'admin/campaigns',
      campaignsById: 'admin/campaigns/{campaignId}',
      customer: 'customers/me',
      login: 'login',
      tos: 'tos',
      uploadImage: 'resources/image',
      uploadText: 'resources/text',
    },
  },
  permissions: {
    access: [{
      name: 'campaigns_all_view',
      title: 'View All Campaigns',
    }, {
      name: 'campaigns_contributors_add',
      title: 'Add Contributors to Campaigns',
    }, {
      name: 'campaigns_contributors_remove',
      title: 'Remove Contributors from Campaigns',
    }],
    create: {
      name: 'campaigns_create',
      title: 'Create Campaigns',
    },
    update: {
      name: 'campaigns_update',
      title: 'Update Campaigns',
    },
    delete: {
      name: 'campaigns_delete',
      title: 'Delete Campaigns',
    },
  },
  sort: {
    campaigns: [{
      id: 0,
      name: 'Newest',
      field: 'updatedAt',
      asc: false,
    }, {
      id: 1,
      name: 'Oldest',
      field: 'updatedAt',
      asc: true,
    }, {
      id: 2,
      name: 'Alphabetical (A-Z)',
      field: 'name',
      asc: true,
    }, {
      id: 3,
      name: 'Alphabetical (Z-A)',
      field: 'name',
      asc: false,
    }],
  },
  pagination: {
    campaigns: {
      pageSize: 20,
    },
  },
  maxChars: {
    campaigns: {
      name: 50,
      shortDescription: 120,
      longDescription: 600,
      guidelines: {
        positive: 180,
        negative: 180,
      },
    },
  },
  maxValues: {
    campaigns: {
      guidelines: {
        positive: 10,
        negative: 10,
      },
    },
  },
  errors: {
    campaigns: {
      duplicateName: 'Sorry, this campaign name is already in use. Please select another name.',
    },
    uploadImage: {
      fail: 'Sorry, couldn\'t process the file, try to upload it again.',
      invalidImage: 'Sorry, the file you are trying to upload is not allowed. You can upload jpg, ' +
                'png o gif files.',
      invalidSize: 'Sorry, the file you are trying to upload exceed the {{maxFileSize}} allowed.',
    },
  },
  settings: {
    campaigns: {
      skipModeration: {
        key: 'media_flow_steps_to_skip',
        val: ['pre_moderation'],
      },
    },
  },
};



// WEBPACK FOOTER //
// ./config/frontend.config.js